module.exports = __webpack_public_path__ + "static/media/LEDWall_in.f288dedd.jpg";